import styled from 'styled-components';

export const StyledLangDropdown = styled.div`
  color: ${props => props.theme.font.colors.primary};
  background: ${({ bgColor }) => bgColor};
  transition: background-color 200ms ease-in-out;
  cursor: pointer;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
  width: auto;
  height: 100%;
  display: inline-block;
  position: relative;
  font-size: 12px;

  @media (max-width: ${props => props.theme.screens.md}) {
    padding: 0;
  }

  @media (min-width: ${props => props.theme.screens.md}) {
    &:hover,
    &.active {
      background-color: ${props => props.bgColor || props.theme.colors.secondary};
    }

    &:hover span.currentLang {
      color: ${props => props.theme.font.colors.secondary};
    }
  }

  .currentLang {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    &:hover {
    }

    @media (max-width: ${props => props.theme.screens.md}) {
      justify-content: flex-start;
    }

    &::after {
      width: 0;
      height: 0;
      margin-left: 0.255em;
      vertical-align: 0.255em;
      content: '';
      border-top: 0.3em solid;
      border-right: 0.3em solid transparent;
      border-bottom: 0;
      border-left: 0.3em solid transparent;
    }

    .fas.fa-comment {
      display: none;
      color: ${props => props.theme.font.colors.primary};
      margin-right: 10px;

      @media (max-width: ${props => props.theme.screens.md}) {
        display: initial;
      }
    }

    .shortLang {
      white-space: nowrap;
      @media (max-width: ${props => props.theme.screens.md}) {
        display: none;
      }
    }

    .baseLang {
      @media (min-width: ${props => props.theme.screens.md}) {
        display: none;
      }
    }
  }

  .dropdownOptions {
    display: none;
    font-size: 12px;
    position: absolute;
    margin-top: 16px;
    z-index: 99999;
    left: 0;
    min-width: 5rem;
    padding: 0;
    flex-wrap: wrap;
    background: ${props => props.theme.colors.bg};
    overflow: hidden;
    border: 1px solid #f2f2f2;
    box-shadow: 0px 3px 8px #00000036;

    &.open {
      display: flex;
    }

    @media (max-width: ${props => props.theme.screens.md}) {
      border-radius: 0.25rem;
    }

    .dropdownItem {
      padding: 5px 10px;
      cursor: pointer;
      width: 100%;

      .fas.fa-comment {
        color: ${props => props.theme.font.colors.primary};
        margin-right: 10px;
        display: none;

        @media (max-width: ${props => props.theme.screens.md}) {
          display: initial;
        }
      }

      &.active {
        background-color: ${props => props.hoverBkg || props.theme.colors.secondary};
        color: ${props => props.hoverColor || props.theme.font.colors.secondary};
      }

      @media (min-width: ${props => props.theme.screens.md}) {
        &:hover {
          background-color: ${props => props.hoverBkg || props.theme.colors.secondary};
          color: ${props => props.hoverColor || props.theme.font.colors.secondary};
        }
      }

      .shortLang {
        @media (max-width: ${props => props.theme.screens.md}) {
          display: none;
        }
      }

      .baseLang {
        @media (min-width: ${props => props.theme.screens.md}) {
          display: none;
        }
      }
    }
  }
`;
